/**
 * filterLinksByCategory
 * @param {array} categories - list of selected categories to be matched
 * @param {array} links - list of links data
 * @returns {array} filtered list of links data based on categories
 */
const filterLinksByCategory = (selectedCategoryIds, links) => {
  if (!selectedCategoryIds.length) {
    return links;
  }

  return links?.filter((link) => {
    const linkCategoryIds = link?.entityContent?.categories.map(({ id }) => id);
    return linkCategoryIds.some((linkCategoryId) =>
      selectedCategoryIds.includes(linkCategoryId)
    );
  });
};

export default filterLinksByCategory;
